// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as InsightsIndexRouteImport } from './routes/insights/index'
import { Route as InsightsSlugRouteImport } from './routes/insights/$slug'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsSlugRouteImport } from './routes/projects/$slug'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as ServicesSlugRouteImport } from './routes/services/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const InsightsIndexRoute = InsightsIndexRouteImport.update({
            id: '/insights/',path: '/insights/',getParentRoute: () => rootRouteImport
          })
const InsightsSlugRoute = InsightsSlugRouteImport.update({
            id: '/insights/$slug',path: '/insights/$slug',getParentRoute: () => rootRouteImport
          })
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => rootRouteImport
          })
const ProjectsSlugRoute = ProjectsSlugRouteImport.update({
            id: '/projects/$slug',path: '/projects/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,CareersRoute: CareersRoute,ContactRoute: ContactRoute,InsightsSlugRoute: InsightsSlugRoute,ProjectsSlugRoute: ProjectsSlugRoute,ServicesSlugRoute: ServicesSlugRoute,InsightsIndexRoute: InsightsIndexRoute,ProjectsIndexRoute: ProjectsIndexRoute,ServicesIndexRoute: ServicesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)